export default __webpack_public_path__ + "static/media/Ellipse297.c18c1be4.png";